import { useState, useEffect, useRef } from "react";
import {
  Container,
  Box,
  Paper,
  Typography,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableCell,
  Table,
  TableHead,
  TableBody,
  TableRow,
  
  IconButton,
  Tooltip,
  /* MenuItem,Grid, */
  
  /* Select,Modal,
  InputLabel,
  TextField,
  FormControl,
  Stack,
  InputAdornment */
} from "@mui/material";
import dayjs from "dayjs";
import { Add, } from "@mui/icons-material";
import { CalendarToday } from "@mui/icons-material";
import { FaUpload, FaDownload} from "react-icons/fa6";
import { BsPersonVcard } from "react-icons/bs";
import Logocolor from "../../../Image/Logo.png";
import { formatCLP } from "../../../Components/FuncionesGenerales/FormatoCLP";
import {
  Texto,
  buttonCancelar,
  TituloPrincipal,
  Titulo,
  SubTitulo,
  SubTitulodos,
  buttonGuardar,
  modalStyle,
   Input,
   inputFechaGrande

} from "../../../Layouts/CustomStyles";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
/* import { FaTrashCan } from "react-icons/fa6";
import { formatCLP } from "../../../Components/FuncionesGenerales/FormatoCLP"; */

import { DataGrid } from "@mui/x-data-grid";
/* import { useGetRemuneracion, useRemuneracion } from "../../../Services/Remuneracion";
import { useGetSucursal } from "../../../Services/Sucursales";
import { useGetProfesional } from "../../../Services/Profesional"; */
import { useGetCategoriasRME, useRemuneracionesEgresos } from "../../../Services/EgresosRME";
/* import { useUserSuperEmpresa } from "../../../Context/AuthContext";
 */

export const RemuneracionIndex = () => {
   /* const { Usuario } = useUserSuperEmpresa(); */
/*   const { Remuneracion, loadingRemuneracion, errorRemuneracion, refetchRemuneracion } = useGetRemuneracion();
  const { crearRemuneracion, eliminarRemuneracion, editarRemuneracion, subirPDFRemuneracion,
    descargarPDFRemuneracion, } = useRemuneracion(); */
  /* const { profesional } = useGetProfesional(); */
  const { egresosremu,
    total,
    loading,
    error,
    cargarRemuneraciones} =useRemuneracionesEgresos();
    console.log(egresosremu)
  /* const { categorias } = useGetCategoriasRME();
  const { sucursales } = useGetSucursal();
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); */
  /* const [open, setOpen] = useState(false); */
  /* const [openEdit, setOpenEdit] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false); */
  const [openDetalle, setOpenDetalle] = useState(false);
const [detalleMes, setDetalleMes] = useState(null);

const abrirDetalle = (row) => {
  setDetalleMes(row);
  setOpenDetalle(true);
};

const cerrarDetalle = () => {
  setOpenDetalle(false);
  setDetalleMes(null);
};

  useEffect(() => {
    cargarRemuneraciones();
  }, []);
  const agruparPorMes = (egresos) => {
  const grupos = {};

  egresos.forEach((e) => {
    const fecha = dayjs(e.date);
    const key = fecha.format("YYYY-MM"); // 👈 año-mes

    if (!grupos[key]) {
      grupos[key] = {
        id: key,
        periodo: fecha.format("MMMM YYYY"),
        total: 0,
        registros: [],
      };
    }

    grupos[key].total += Number(e.amount);
    grupos[key].registros.push(e);
  });

  return Object.values(grupos);
};

const rows = agruparPorMes(egresosremu);

const columns = [
  {
    field: "periodo",
    headerName: "Periodo",
    flex: 1,
  },
  {
    field: "total",
    headerName: "Monto Total",
    flex: 1,
    renderCell: (params) => formatCLP(params.value),
  },
 
  {
    field: "acciones",
    headerName: "Acciones",
    flex:1,
    renderCell: (params) => (
       <Tooltip title="Ver detalle de remuneración" arrow>
            <IconButton onClick={() => abrirDetalle(params.row)} sx={{ background: '#28b6c6ff' }}>
              <BsPersonVcard style={{ color: '#fff' }} />
            </IconButton>
          </Tooltip>
    
    ),
  },
];
  /* const [nuevoRemuneracion, setNuevoRemuneracion] = useState({
    profesional_id: "",
    fecha: "",
    tipo_afp: "",
    porcentaje_afp: "",
    monto_afp: "",
    tipo_salud: "",
    porcentaje_salud: "",
    monto_salud: "",
    dias_trabajados: "",
    horas_extras: "",
    horas_faltadas: "",
    cargas_familiares: "",
    sueldo_base: "",
    gratificacion_legal: "",
    total_imponible: "",
    total_no_imponible: "",
    seguro_cesantia: "",
    total_descuentos_legales: "",
    total_liquido: "",
    descuento_salud: "",
    branch_id: "",
    user_id: Usuario?.id,
    expense_category_id: "",
  }); */
/*   const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [openEliminarDialog, setOpenEliminarDialog] = useState(false); */
/* const [idEliminar, setIdEliminar] = useState(null); // Para almacenar el id del item a eliminar
const [busqueda, setBusqueda] = useState("");
const [openUploadDialog, setOpenUploadDialog] = useState(false);
const [selectedId, setSelectedId] = useState(null);
const [selectedFile, setSelectedFile] = useState(null); */
/* 
const handleOpenUploadDialog = (id) => {
  setSelectedId(id);
  setSelectedFile(null);
  setOpenUploadDialog(true);
};

const handleCloseUploadDialog = () => {
  setOpenUploadDialog(false);
};

  const handleOpenEliminarDialog = (id) => {
  setIdEliminar(id); // Establece el ID del elemento que deseas eliminar
  setOpenEliminarDialog(true); // Abre el modal
};

const handleCloseEliminarDialog = () => {
  setOpenEliminarDialog(false); // Cierra el modal
};

  const handleChange = (e) => {
    setNuevoRemuneracion({ ...nuevoRemuneracion, [e.target.name]: e.target.value });
  };

  const handleOpenModal = (row) => {
    setSelectedRow(row);
    setOpenModal(true);
  };
  const handleCloseModal = () => setOpenModal(false);
  
  const rows = Remuneracion
  ?.filter(item =>
    item.profesional?.nombre?.toLowerCase().includes(busqueda.toLowerCase())
  )
  .map(item => ({
    id: item.id,
    ...item
  })) || [];

  const columns = [
    {
      field: "fecha",
      headerName: "Fecha",
      flex: 0.5,
      renderCell: (params) =>
        params.value
          ? params.value.split('T')[0].split('-').reverse().join('/')
          : ""
    },

    {
      field: "profesional_nombre",
      headerName: "Profesional",
      flex: 1,
      renderCell: (params) => params.row?.profesional?.nombre || "Desconocido"
    },
    {
      field: "profesional_rut",
      headerName: "RUT",
      flex: 1,
      renderCell: (params) => params.row?.profesional?.rut || ""
    },
    {
      field: "total_imponible",
      headerName: "Sueldo Bruto",
      flex: 1,
      renderCell: (params) => new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 }).format(params.value || 0)
    },
    {
      field: "total_liquido",
      headerName: "Sueldo Líquido",
      flex: 1,
      renderCell: (params) => new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 }).format(params.value || 0)
    },
    {
      field: "acciones",
      headerName: "Acciones",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Tooltip title="Ver detalle de remuneración" arrow>
            <IconButton onClick={() => handleOpenModal(params.row)} sx={{ background: '#28b6c6ff' }}>
              <BsPersonVcard style={{ color: '#fff' }} />
            </IconButton>
          </Tooltip>
     <Tooltip title="Subir PDF">
  <IconButton
    sx={{ background: "#1976d2", color: "#fff" }}
    onClick={() => handleOpenUploadDialog(params.row.id)}
  >
    <FaUpload />
  </IconButton>
</Tooltip>

<Tooltip title="Descargar PDF">
  <span>
    <IconButton
      sx={{
        background: params.row.pdf ? "#2bad32ff" : "#bdbdbd",
        color: "#fff",
      }}
      disabled={!params.row.pdf}
      onClick={() => descargarPDFRemuneracion(params.row.id)}
    >
      <FaDownload />
    </IconButton>
  </span>
</Tooltip>


          <Tooltip title="Editar">
            <button className="edit-button"  onClick={() => handleOpenEditModal(params.row)}>
              <svg className="edit-svgIcon" viewBox="0 0 512 512">
                <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
              </svg>
            </button>
          </Tooltip>
          <Tooltip title="Eliminar">
            <button className="delete-button"  onClick={() => handleOpenEliminarDialog(params.row.id)} >
              <FaTrashCan className="delete-svgIcon" />
            </button>
          </Tooltip>
        </Box>
      )
    }
  ];


const handleSubmitUploadPDF = async () => {
  if (!selectedFile) return;

  await subirPDFRemuneracion(selectedId, selectedFile);

  setOpenUploadDialog(false);
  refetchRemuneracion();
};


 const handleOpenEditModal = (row) => {

  setSelectedRow(row);

  setNuevoRemuneracion({
    branch_id: row.expense?.branch_id?? "",
    expense_category_id: row.expense?.expense_category_id ?? "",
    profesional_id: row.profesional_id,
    fecha: row.fecha?.split("T")[0] ?? "",
    tipo_afp: row.tipo_afp,
    porcentaje_afp: row.porcentaje_afp,
    monto_afp: row.monto_afp,
    tipo_salud: row.tipo_salud,
    porcentaje_salud: row.porcentaje_salud,
    monto_salud: row.monto_salud,
    dias_trabajados: row.dias_trabajados,
    horas_extras: row.horas_extras,
    horas_faltadas: row.horas_faltadas,
    cargas_familiares: row.cargas_familiares,
    sueldo_base: row.sueldo_base,
    gratificacion_legal: row.gratificacion_legal,
    total_imponible: row.total_imponible,
    total_no_imponible: row.total_no_imponible,
    seguro_cesantia: row.seguro_cesantia,
    total_descuentos_legales: row.total_descuentos_legales,
    total_liquido: row.total_liquido,
    descuento_salud: row.descuento_salud,
    user_id: Usuario?.id,
  });

  setOpenEdit(true);
};


  const handleEditClose = () => setOpenEdit(false);

  

  // Parseamos la fecha UTC
  const fechaReal = selectedRow?.fecha.split('T')[0];

  const handleCrear = async () => {


    setEnviandoAlert(true);
    try {
     await crearRemuneracion(nuevoRemuneracion);


      setAlertMessage("Remuneración creado exitosamente.");
      setSuccessAlertOpen(true);
      setOpen(false);
      setNuevoRemuneracion({profesional_id: "",
    fecha: "",
    tipo_afp: "",
    porcentaje_afp: "",
    monto_afp: "",
    tipo_salud: "",
    porcentaje_salud: "",
    monto_salud: "",
    dias_trabajados: "",
    horas_extras: "",
    horas_faltadas: "",
    cargas_familiares: "",
    sueldo_base: "",
    gratificacion_legal: "",
    total_imponible: "",
    total_no_imponible: "",
    seguro_cesantia: "",
    total_descuentos_legales: "",
    total_liquido: "",
    descuento_salud: "",
    branch_id: "",
    user_id: Usuario?.id,
    expense_category_id: "",
  });

  refetchRemuneracion();
    } catch (err) {
      setAlertMessage(err || "Error al crear Remuneración");
      setErrorAlertOpen(true);
    } finally {
      setEnviandoAlert(false);
    }
  };


  const handleSubmitEdit = async () => {
  setEnviandoAlert(true);

 try {
     await editarRemuneracion(selectedRow.id, nuevoRemuneracion);

 
    setAlertMessage("Remuneración editada correctamente");
    setSuccessAlertOpen(true);
    refetchRemuneracion();
    setOpenEdit(false);
     setNuevoRemuneracion({profesional_id: "",
    fecha: "",
    tipo_afp: "",
    porcentaje_afp: "",
    monto_afp: "",
    tipo_salud: "",
    porcentaje_salud: "",
    monto_salud: "",
    dias_trabajados: "",
    horas_extras: "",
    horas_faltadas: "",
    cargas_familiares: "",
    sueldo_base: "",
    gratificacion_legal: "",
    total_imponible: "",
    total_no_imponible: "",
    seguro_cesantia: "",
    total_descuentos_legales: "",
    total_liquido: "",
    descuento_salud: "",
    branch_id: "",
    user_id: Usuario?.id,
    expense_category_id: "",
  });

  refetchRemuneracion();
   } catch (err) {
      setAlertMessage(err || "Error al editar Remuneración");
      setErrorAlertOpen(true);
    } finally {
      setEnviandoAlert(false);
    }

};

const handleEliminar = async () => {
  if (idEliminar) {
    setEnviandoAlert(true);
    try {
      await eliminarRemuneracion(idEliminar); // Llamada al método de eliminación
      setOpenEliminarDialog(false); // Cierra el modal
       setAlertMessage("Remuneración eliminada correctamente");
    setSuccessAlertOpen(true);
    refetchRemuneracion();
      refetchRemuneracion(); // Refresca la lista
    } catch (err) {
      setAlertMessage(err || "Error al eliminar Remuneración");
      setErrorAlertOpen(true);
    } finally {
      setEnviandoAlert(false);
    }

  }
};


const porcentajesAFP = {
        Habitat: 10 + 1.27,
        Provida: 10 + 1.45,
        Capital: 10 + 1.44,
        Cuprum: 10 + 1.44,
        Modelo: 10 + 0.58,
        PlanVital: 10 + 1.16,
        Uno: 10 + 0.49,
    };

    useEffect(() => {
        if (nuevoRemuneracion.total_imponible && nuevoRemuneracion.porcentaje_afp) {
            const monto =
                (Number(nuevoRemuneracion.total_imponible) *
                    Number(nuevoRemuneracion.porcentaje_afp)) /
                100;

            setNuevoRemuneracion(prev => ({
                ...prev,
                monto_afp: Math.round(monto)
            }));
        }
    }, [
        nuevoRemuneracion.total_imponible,
        nuevoRemuneracion.porcentaje_afp
    ]);

    const saludPercentajes = {
        Fonasa: 7,
        Isapre: 7,
    };

    useEffect(() => {
        if (nuevoRemuneracion.total_imponible && nuevoRemuneracion.porcentaje_salud) {
            const monto =
                (Number(nuevoRemuneracion.total_imponible) *
                    Number(nuevoRemuneracion.porcentaje_salud)) /
                100;

            setNuevoRemuneracion(prev => ({
                ...prev,
                monto_salud: Math.round(monto)
            }));
        }
    }, [
        nuevoRemuneracion.total_imponible,
        nuevoRemuneracion.porcentaje_salud
    ]);

    useEffect(() => {
        const total =
            (Number(nuevoRemuneracion.monto_afp) || 0) +
            (Number(nuevoRemuneracion.monto_salud) || 0) +
            (Number(nuevoRemuneracion.seguro_cesantia) || 0)+
            (Number(nuevoRemuneracion.descuento_salud) || 0);

        setNuevoRemuneracion(prev => ({
            ...prev,
            total_descuentos_legales: total
        }));
    }, [
        nuevoRemuneracion.monto_afp,
        nuevoRemuneracion.monto_salud,
        nuevoRemuneracion.seguro_cesantia,
        nuevoRemuneracion.descuento_salud
    ]);
    // seguro de cesantia 
    const porcentajeCesantia = 0.6; // 0,6%

    useEffect(() => {
        if (nuevoRemuneracion.total_imponible) {
            const monto = Number(nuevoRemuneracion.total_imponible) * (porcentajeCesantia / 100);

            setNuevoRemuneracion(prev => ({
                ...prev,
                seguro_cesantia: Math.round(monto)
            }));
        }
    }, [nuevoRemuneracion.total_imponible]);

    useEffect(() => {
        const imponible = Number(nuevoRemuneracion.total_imponible) || 0;

        if (imponible > 0) {
            // 25% del imponible
            const gratificacion25 = imponible * 0.25;

            // Tope legal mensual basado en IMM = 529.000
            const topeLegal = (4.75 * 529000) / 12; // = 209396 exacto

            const gratificacion = Math.min(
                Math.round(gratificacion25),
                Math.round(topeLegal)
            );

            setNuevoRemuneracion(prev => ({
                ...prev,
                gratificacion_legal: gratificacion
            }));
        }

    }, [nuevoRemuneracion.total_imponible]);

    useEffect(() => {
        const imponible = Number(nuevoRemuneracion.total_imponible) || 0;
        const descuentos = Number(nuevoRemuneracion.total_descuentos_legales) || 0;

        const liquido = imponible - descuentos;

        setNuevoRemuneracion(prev => ({
            ...prev,
            total_liquido: liquido,
            sueldo_base: liquido
        }));
    }, [
        nuevoRemuneracion.total_imponible,
        nuevoRemuneracion.total_descuentos_legales
    ]);
 */

  return (
    <Container maxWidth="xl" sx={{ py: 5 }}>
      <Paper elevation={4} sx={{ p: 4, borderRadius: "20px", background: "linear-gradient(145deg, #ffffff, #f4f6f8)" }}>
        <Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Box display="flex" alignItems="center" gap={2}>
            <img src={Logocolor} alt="Logo Clínica Activa" style={{ width: 55, height: 55, objectFit: "contain" }} />
            <Typography variant="h5" sx={Texto}>
              Remuneración RME
            </Typography>
          </Box>

          {/* <Button variant="contained" startIcon={<Add />} sx={buttonGuardar} onClick={handleOpen}>
            Crear Liquidación
          </Button> */}
        </Box>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "300px",
              gap: 2,
              position: "relative"
            }}
          >
            {/* Círculo */}
            <CircularProgress size={90} thickness={4} sx={{ color: '#6fd385ff' }} />

            {/* Imagen centrada encima del círculo */}
            <Box
              component="img"
              src={Logocolor}
              alt="Logo"
              sx={{
                width: "55px",
                height: "55px",
                position: "absolute",
                top: "90px"
              }}
            />

            <Typography sx={{ fontFamily: "Poppins", fontSize: "18px", mt: 2 }}>
              Cargando...
            </Typography>
          </Box>
        ) : error? (
          <Typography sx={{ color: "red", mt: 3 }}>Error al cargar remuneraciones</Typography>
        ) : (
          <Box sx={{ height: 600, width: "100%" }}>
            <DataGrid
  rows={rows}
  columns={columns}
  autoHeight
  loading={loading}
  disableRowSelectionOnClick
  pageSizeOptions={[5, 10]}
  rowsPerPageOptions={[10, 20, 50]}
              sx={{
                fontFamily: 'Poppins, sans-serif',
                '& .MuiDataGrid-columnHeaders': { color: '#113e21ff', fontWeight: 600, textTransform: 'capitalize' },
                '& .MuiDataGrid-cell': { textTransform: 'capitalize' },
              }}
 />

          {/*   <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
 

  <TextField
    size="small"
    variant="outlined"
    placeholder="Buscar profesional..."
    value={busqueda}
    onChange={(e) => setBusqueda(e.target.value)}
    sx={{ width: 250, borderRadius:'50px' }}
  />

  
</Box>

          <Box sx={{ height: 600, width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10, 20, 50]}
              sx={{
                fontFamily: 'Poppins, sans-serif',
                '& .MuiDataGrid-columnHeaders': { color: '#113e21ff', fontWeight: 600, textTransform: 'capitalize' },
                '& .MuiDataGrid-cell': { textTransform: 'capitalize' },
              }}
            />
          </Box> */}
          </Box>
        )}
      </Paper>
<Dialog open={openDetalle} onClose={cerrarDetalle} maxWidth="xl" fullWidth>
  <DialogTitle style={{fontFamily:'Poppins'}}>
    Detalle remuneraciones – {detalleMes?.periodo}
  </DialogTitle>

  <DialogContent>
    <Typography variant="subtitle1" sx={{ mb: 2, fontFamily:'Poppins' }}>
      Total mes:{" "}
      <strong>
        $ {detalleMes?.total.toLocaleString("es-CL")}
      </strong>
    </Typography>

    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell style={{fontFamily:'Poppins'}}>Fecha</TableCell>
          <TableCell style={{fontFamily:'Poppins'}}>Sucursal</TableCell>
            <TableCell style={{fontFamily:'Poppins'}}>Categoria</TableCell>  
            <TableCell style={{fontFamily:'Poppins'}}>Descripción</TableCell>
          <TableCell align="right">Monto</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {detalleMes?.registros.map((r) => (
          <TableRow key={r.id}>
            <TableCell style={{fontFamily:'Poppins'}}>{dayjs(r.date).format("DD-MM-YYYY")}</TableCell>
            <TableCell style={{fontFamily:'Poppins'}}>{r.branch?.name}</TableCell>
             <TableCell style={{fontFamily:'Poppins'}}>{r.expense_category
?.name}</TableCell>
 <TableCell style={{fontFamily:'Poppins'}}>{r.description}</TableCell>
            <TableCell align="right" style={{fontFamily:'Poppins'}}>
              $ {Number(r.amount).toLocaleString("es-CL")}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </DialogContent>

  <DialogActions>
    <Button onClick={cerrarDetalle}>Cerrar</Button>
  </DialogActions>
</Dialog>
    {/*   <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle sx={TituloPrincipal}>Detalle Remuneración</DialogTitle>

        <DialogContent>
          {selectedRow && (
            <Box sx={{ fontFamily: "monospace", fontSize: 14 }}>
              <Typography variant="subtitle2" align="center" sx={{ ...Titulo, mb: 3 }}>Liquidación de sueldo</Typography>
              <Typography variant="body2" sx={{ ...SubTitulo, mb: 3 }}>Remuneración del mes {new Date(selectedRow.fecha).toLocaleString("es-CL", { month: "long", year: "numeric" })}</Typography>


              <Box mt={1} mb={2} sx={{ border: '1px solid #59c4a4ff', p: 2 }}>
                <Grid container spacing={1}>
                  <Grid size={4}><Typography sx={Texto}>R.U.T.</Typography></Grid>
                  <Grid size={6}><Typography sx={Texto}>TRABAJADOR</Typography></Grid>


                  <Grid size={4}><Typography sx={SubTitulodos}>{selectedRow.profesional?.rut}</Typography></Grid>
                  <Grid size={6}><Typography sx={SubTitulodos}>{selectedRow.profesional?.nombre}</Typography></Grid>

                </Grid>
              </Box>

              <Box mt={1} mb={2} sx={{ border: '1px solid #59c4a4ff', p: 2 }}>
                <Grid container spacing={1}>

                  <Grid size={6}>
                    <Typography sx={Texto}> A.F.P </Typography>
                    <Typography sx={SubTitulodos} > {selectedRow.tipo_afp} {selectedRow.porcentaje_afp}%  </Typography>
                    <Typography sx={SubTitulodos} > {formatCLP(selectedRow.monto_afp)} </Typography>
                  </Grid>
                  <Grid size={6}>
                    <Typography sx={Texto}> Isapre: </Typography>
                    <Typography sx={SubTitulodos}> {selectedRow.tipo_salud}</Typography>
                    <Typography sx={SubTitulodos}>  {formatCLP(selectedRow.monto_salud)} </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Box mt={1} mb={2} sx={{ border: '1px solid #59c4a4ff', p: 2 }}>
                <Grid container spacing={1}>
                  <Grid size={2}><Typography sx={Texto}>Días</Typography></Grid>
                  <Grid size={2}><Typography sx={Texto}>Horas Extras</Typography></Grid>
                  <Grid size={2}><Typography sx={Texto}>Horas Faltadas</Typography></Grid>
                  <Grid size={2}><Typography sx={Texto}>Cargas</Typography></Grid>
                  <Grid size={2}><Typography sx={Texto}>Imponible</Typography></Grid>
                  <Grid size={2}><Typography sx={Texto}>Tributables</Typography></Grid>

                  <Grid size={2}><Typography sx={SubTitulodos}>{selectedRow.dias_trabajados}</Typography></Grid>
                  <Grid size={2}><Typography sx={SubTitulodos}>{selectedRow.horas_extras}</Typography></Grid>
                  <Grid size={2}><Typography sx={SubTitulodos}>{selectedRow.horas_faltadas}</Typography></Grid>
                  <Grid size={2}><Typography sx={SubTitulodos}>{selectedRow.cargas_familiares}</Typography></Grid>
                  <Grid size={2}><Typography sx={SubTitulodos}>{formatCLP(selectedRow.total_imponible)}</Typography></Grid>
                  <Grid size={2}><Typography sx={SubTitulodos}>{formatCLP(selectedRow.total_liquido)}</Typography></Grid>
                </Grid>
              </Box>

              <Box mt={1} mb={2} sx={{ border: '1px solid #59c4a4ff', p: 2 }}>
                <Grid container spacing={1}>
                  <Grid size={6}>
                    <Typography variant="subtitle2" sx={SubTitulo}>Haberes</Typography>
                    <hr />
                    <Typography sx={SubTitulodos}><strong>Sueldo Base:</strong> {formatCLP(selectedRow.sueldo_base)}</Typography>
                    <Typography sx={SubTitulodos}> <strong>Gratificación Legal:</strong> {formatCLP(selectedRow.gratificacion_legal)}</Typography>
                    <Typography sx={SubTitulodos}> <strong>Total Imponible:</strong> {formatCLP(selectedRow.total_imponible)}</Typography>
                    <Typography sx={SubTitulodos}> <strong>Total No Imponible: </strong>{formatCLP(selectedRow.total_no_imponible || 0)}</Typography>
                  </Grid>
                  <Grid size={6}>
                    <Typography variant="subtitle2" sx={SubTitulo}>Descuentos</Typography>
                    <hr />
                    <Typography sx={SubTitulodos}> <strong>Previsión: </strong>{formatCLP(selectedRow.monto_afp)}</Typography>
                    <Typography sx={SubTitulodos}> <strong>Salud: </strong>{formatCLP(selectedRow.monto_salud)}</Typography>
                    <Typography sx={SubTitulodos}> <strong>Seguro Cesantía: </strong> {formatCLP(selectedRow.seguro_cesantia)}</Typography>
                    <Typography sx={SubTitulodos}> <strong>Total Descuentos Legales: </strong> {formatCLP(selectedRow.total_descuentos_legales)}</Typography>
                    <Typography sx={SubTitulodos}> <strong>Otros descuentos: </strong> </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Box mt={2} sx={{ border: '1px solid #59c4a4ff', p: 2 }} display="flex" justifyContent="space-between">
                <Typography sx={SubTitulodos}> <strong>Total Haberes: </strong> {formatCLP(selectedRow.total_imponible)}</Typography>
                <Typography sx={SubTitulodos}>  <strong>Total Descuentos: </strong>{formatCLP(selectedRow.total_descuentos_legales)}</Typography>
              </Box>

              <Box mt={1} sx={{ border: '1px solid #59c4a4ff', p: 2 }} display="flex" justifyContent="space-between">
                <Typography sx={SubTitulodos}>
                  <strong>Fecha: </strong>
                  {fechaReal.replaceAll("-", "/")}
                </Typography>

                <Typography sx={SubTitulodos}> <strong>Alcance Líquido: </strong> {formatCLP(selectedRow.total_liquido)}</Typography>
              </Box>


            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseModal} variant="contained" sx={buttonCancelar}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

     <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
  <DialogTitle sx={Texto}>Crear nueva Liquidación</DialogTitle>

  <DialogContent>
    <Stack spacing={2} sx={{ mt: 1 }}>

      <FormControl fullWidth sx={Input}>
        <InputLabel>Tipo</InputLabel>
        <Select
          label="Tipo"
          value={nuevoRemuneracion.expense_category_id}
          onChange={(e) =>
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              expense_category_id: Number(e.target.value)
            })
          }
        >
          {categorias
            ?.filter((cat) => cat.name.toLowerCase() === "remuneración" || cat.name.toLowerCase() === "remuneracion")
            .map((cat) => (
              <MenuItem key={cat.id} value={cat.id}>
                {cat.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

     
      <TextField
        name="fecha"
        label="Fecha"
        type="date"
        value={nuevoRemuneracion.fecha}
        onChange={handleChange}
        fullWidth
        InputLabelProps={{ shrink: true }}
        sx={{ ...inputFechaGrande, mt: 2, mb: 2 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CalendarToday />
            </InputAdornment>
          ),
        }}
      />


      <FormControl fullWidth sx={{ ...Input, mt: 2 }}>
        <InputLabel>Profesional</InputLabel>
        <Select
          name="profesional_id"
          value={nuevoRemuneracion.profesional_id ?? ""}
          label="Profesional"
          onChange={handleChange}
        >
          {profesional?.map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.nombre}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

    
      <FormControl fullWidth sx={Input}>
        <InputLabel id="sucursal-label">Sucursal</InputLabel>
        <Select
          labelId="sucursal-label"
          name="branch_id"
          value={nuevoRemuneracion.branch_id ?? ""}
          onChange={handleChange}
          label="Sucursal"
        >
          <MenuItem value="">General</MenuItem>
          {sucursales?.map((s) => (
            <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

 
      <TextField
        name="total_imponible"
        label="Total imponible"
        fullWidth
        sx={Input}
        value={formatCLP(nuevoRemuneracion.total_imponible || 0)}
        onChange={(e) => {
          const rawValue = e.target.value.replace(/\./g, "").replace(/\$/g, "");
          setNuevoRemuneracion({
            ...nuevoRemuneracion,
            total_imponible: Number(rawValue) || 0
          });
        }}
      />

 
      <Box display="flex" gap={2} mt={2}>
        <FormControl fullWidth sx={Input}>
          <InputLabel>Tipo AFP</InputLabel>
          <Select
            name="tipo_afp"
            value={nuevoRemuneracion.tipo_afp}
            label="Tipo AFP"
            onChange={(e) => {
              const tipo = e.target.value;
              const porcentaje = porcentajesAFP[tipo] ?? 0;

              setNuevoRemuneracion({
                ...nuevoRemuneracion,
                tipo_afp: tipo,
                porcentaje_afp: porcentaje.toFixed(2),
              });
            }}
          >
            <MenuItem value="Habitat">AFP Habitat</MenuItem>
            <MenuItem value="Provida">AFP Provida</MenuItem>
            <MenuItem value="Capital">AFP Capital</MenuItem>
            <MenuItem value="Cuprum">AFP Cuprum</MenuItem>
            <MenuItem value="Modelo">AFP Modelo</MenuItem>
            <MenuItem value="PlanVital">AFP PlanVital</MenuItem>
            <MenuItem value="Uno">AFP Uno</MenuItem>
          </Select>
        </FormControl>

        <TextField
          name="porcentaje_afp"
          sx={Input}
          label="% AFP"
          type="number"
          fullWidth
          value={nuevoRemuneracion.porcentaje_afp}
          onChange={handleChange}
        />

        <TextField
          name="monto_afp"
          sx={Input}
          label="Monto AFP"
          fullWidth
          value={formatCLP(nuevoRemuneracion.monto_afp || 0)}
          onChange={(e) => {
            const numberValue = Number(
              e.target.value.replace(/\./g, "").replace(/\$/g, "").replace(/,/g, "")
            );
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              monto_afp: isNaN(numberValue) ? 0 : numberValue,
            });
          }}
        />
      </Box>

      
      <Box display="flex" gap={2} mt={2}>
        <FormControl fullWidth sx={Input}>
          <InputLabel>Tipo Salud</InputLabel>
          <Select
            name="tipo_salud"
            value={nuevoRemuneracion.tipo_salud}
            label="Tipo Salud"
            onChange={(e) => {
              const tipo = e.target.value;
              const porcentaje = saludPercentajes[tipo] || 0;
              setNuevoRemuneracion({
                ...nuevoRemuneracion,
                tipo_salud: tipo,
                porcentaje_salud: porcentaje,
              });
            }}
          >
            <MenuItem value="Fonasa">Fonasa</MenuItem>
            <MenuItem value="Isapre">Isapre</MenuItem>
          </Select>
        </FormControl>

        <TextField
          name="porcentaje_salud"
          label="% Salud"
          fullWidth
          type="number"
          sx={Input}
          value={nuevoRemuneracion.porcentaje_salud}
          onChange={handleChange}
        />

        <TextField
          name="monto_salud"
          label="Monto Salud"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.monto_salud || 0)}
          onChange={(e) => {
            const numero = Number(
              e.target.value.replace(/\./g, "").replace(/\$/g, "").replace(/,/g, "")
            ) || 0;

            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              monto_salud: numero,
            });
          }}
        />
      </Box>

     
      <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2} mt={2}>
        <TextField name="dias_trabajados" label="Días trabajados" type="number" sx={Input}
          value={nuevoRemuneracion.dias_trabajados}
          onChange={handleChange}
        />

        <TextField name="horas_extras" label="Horas extras" type="number" sx={Input}
          value={nuevoRemuneracion.horas_extras}
          onChange={handleChange}
        />

        <TextField name="horas_faltadas" label="Horas faltadas" type="number" sx={Input}
          value={nuevoRemuneracion.horas_faltadas}
          onChange={handleChange}
        />

        <TextField name="cargas_familiares" label="Cargas" type="number" sx={Input}
          value={nuevoRemuneracion.cargas_familiares}
          onChange={handleChange}
        />

        <TextField
          name="sueldo_base"
          label="Sueldo base"
          sx={Input}
          fullWidth
          value={formatCLP(nuevoRemuneracion.sueldo_base || 0)}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              sueldo_base: Number(raw) || 0
            });
          }}
        />

        <TextField
          name="descuento_salud"
          label="Descuento Salud"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.descuento_salud || 0)}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              descuento_salud: Number(raw) || 0,
            });
          }}
        />

        <TextField
          name="gratificacion_legal"
          label="Gratificación legal"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.gratificacion_legal || 0)}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              gratificacion_legal: Number(raw) || 0,
            });
          }}
        />

        <TextField
          name="total_no_imponible"
          label="Total no imponible"
          fullWidth
          sx={Input}
          value={nuevoRemuneracion.total_no_imponible}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              total_no_imponible: raw === "" ? "" : Number(raw),
            });
          }}
        />

        <TextField
          label="Seguro cesantía"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.seguro_cesantia || 0)}
          disabled
        />

        <TextField
          label="Total descuentos legales"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.total_descuentos_legales || 0)}
          disabled
        />

        <TextField
          name="total_liquido"
          label="Total líquido"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.total_liquido || 0)}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              total_liquido: Number(raw) || 0,
            });
          }}
        />
      </Box>

    </Stack>
  </DialogContent>

  <DialogActions sx={{ p: 2 }}>
    <Button sx={buttonCancelar} onClick={handleClose}>Cancelar</Button>
    <Button variant="contained" sx={buttonGuardar} onClick={handleCrear}>
      Guardar
    </Button>
  </DialogActions>
</Dialog> */}

{/* 
<Dialog open={openEdit} onClose={handleEditClose} fullWidth maxWidth="sm">
  <DialogTitle sx={Texto}>Editar Liquidación</DialogTitle>

  <DialogContent>
            <Stack spacing={2} sx={{ mt: 1 }}>

      {// TIPO FIJO = REMUNERACIÓN 
     <FormControl fullWidth sx={Input}>
  <InputLabel>Tipo</InputLabel>
  <Select
    label="Tipo"
    value={Number(nuevoRemuneracion.expense_category_id) || ""}
    onChange={(e) =>
      setNuevoRemuneracion({
        ...nuevoRemuneracion,
        expense_category_id: Number(e.target.value)
      })
    }
  >
    {categorias
      ?.filter((cat) => 
        cat.name.toLowerCase() === "remuneración" || 
        cat.name.toLowerCase() === "remuneracion"
      )
      .map((cat) => (
        <MenuItem key={cat.id} value={cat.id}>
          {cat.name}
        </MenuItem>
      ))}
  </Select>
</FormControl>


      {// FECHA 
      <TextField
        name="fecha"
        label="Fecha"
        type="date"
        value={nuevoRemuneracion.fecha}
        onChange={handleChange}
        fullWidth
        InputLabelProps={{ shrink: true }}
        sx={{ ...inputFechaGrande, mt: 2, mb: 2 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CalendarToday />
            </InputAdornment>
          ),
        }}
      />

   
      <FormControl fullWidth sx={{ ...Input, mt: 2 }}>
        <InputLabel>Profesional</InputLabel>
        <Select
          name="profesional_id"
          value={nuevoRemuneracion.profesional_id ?? ""}
          label="Profesional"
          onChange={handleChange}
        >
          {profesional?.map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.nombre}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

   
      <FormControl fullWidth sx={Input}>
        <InputLabel id="sucursal-label">Sucursal</InputLabel>
        <Select
          labelId="sucursal-label"
          name="branch_id"
          value={nuevoRemuneracion.branch_id ?? ""}
          onChange={handleChange}
          label="Sucursal"
        >
          <MenuItem value="">General</MenuItem>
          {sucursales?.map((s) => (
            <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        name="total_imponible"
        label="Total imponible"
        fullWidth
        sx={Input}
        value={formatCLP(nuevoRemuneracion.total_imponible || 0)}
        onChange={(e) => {
          const rawValue = e.target.value.replace(/\./g, "").replace(/\$/g, "");
          setNuevoRemuneracion({
            ...nuevoRemuneracion,
            total_imponible: Number(rawValue) || 0
          });
        }}
      />

      <Box display="flex" gap={2} mt={2}>
        <FormControl fullWidth sx={Input}>
          <InputLabel>Tipo AFP</InputLabel>
          <Select
            name="tipo_afp"
            value={nuevoRemuneracion.tipo_afp}
            label="Tipo AFP"
            onChange={(e) => {
              const tipo = e.target.value;
              const porcentaje = porcentajesAFP[tipo] ?? 0;

              setNuevoRemuneracion({
                ...nuevoRemuneracion,
                tipo_afp: tipo,
                porcentaje_afp: porcentaje.toFixed(2),
              });
            }}
          >
            <MenuItem value="Habitat">AFP Habitat</MenuItem>
            <MenuItem value="Provida">AFP Provida</MenuItem>
            <MenuItem value="Capital">AFP Capital</MenuItem>
            <MenuItem value="Cuprum">AFP Cuprum</MenuItem>
            <MenuItem value="Modelo">AFP Modelo</MenuItem>
            <MenuItem value="PlanVital">AFP PlanVital</MenuItem>
            <MenuItem value="Uno">AFP Uno</MenuItem>
          </Select>
        </FormControl>

        <TextField
          name="porcentaje_afp"
          sx={Input}
          label="% AFP"
          type="number"
          fullWidth
          value={nuevoRemuneracion.porcentaje_afp}
          onChange={handleChange}
        />

        <TextField
          name="monto_afp"
          sx={Input}
          label="Monto AFP"
          fullWidth
          value={formatCLP(nuevoRemuneracion.monto_afp || 0)}
          onChange={(e) => {
            const numberValue = Number(
              e.target.value.replace(/\./g, "").replace(/\$/g, "").replace(/,/g, "")
            );
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              monto_afp: isNaN(numberValue) ? 0 : numberValue,
            });
          }}
        />
      </Box>

      <Box display="flex" gap={2} mt={2}>
        <FormControl fullWidth sx={Input}>
          <InputLabel>Tipo Salud</InputLabel>
          <Select
            name="tipo_salud"
            value={nuevoRemuneracion.tipo_salud}
            label="Tipo Salud"
            onChange={(e) => {
              const tipo = e.target.value;
              const porcentaje = saludPercentajes[tipo] || 0;
              setNuevoRemuneracion({
                ...nuevoRemuneracion,
                tipo_salud: tipo,
                porcentaje_salud: porcentaje,
              });
            }}
          >
            <MenuItem value="Fonasa">Fonasa</MenuItem>
            <MenuItem value="Isapre">Isapre</MenuItem>
          </Select>
        </FormControl>

        <TextField
          name="porcentaje_salud"
          label="% Salud"
          fullWidth
          type="number"
          sx={Input}
          value={nuevoRemuneracion.porcentaje_salud}
          onChange={handleChange}
        />

        <TextField
          name="monto_salud"
          label="Monto Salud"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.monto_salud || 0)}
          onChange={(e) => {
            const numero = Number(
              e.target.value.replace(/\./g, "").replace(/\$/g, "").replace(/,/g, "")
            ) || 0;

            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              monto_salud: numero,
            });
          }}
        />
      </Box>

      <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2} mt={2}>
        <TextField name="dias_trabajados" label="Días trabajados" type="number" sx={Input}
          value={nuevoRemuneracion.dias_trabajados}
          onChange={handleChange}
        />

        <TextField name="horas_extras" label="Horas extras" type="number" sx={Input}
          value={nuevoRemuneracion.horas_extras}
          onChange={handleChange}
        />

        <TextField name="horas_faltadas" label="Horas faltadas" type="number" sx={Input}
          value={nuevoRemuneracion.horas_faltadas}
          onChange={handleChange}
        />

        <TextField name="cargas_familiares" label="Cargas" type="number" sx={Input}
          value={nuevoRemuneracion.cargas_familiares}
          onChange={handleChange}
        />

        <TextField
          name="sueldo_base"
          label="Sueldo base"
          sx={Input}
          fullWidth
          value={formatCLP(nuevoRemuneracion.sueldo_base || 0)}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              sueldo_base: Number(raw) || 0
            });
          }}
        />

        <TextField
          name="descuento_salud"
          label="Descuento Salud"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.descuento_salud || 0)}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              descuento_salud: Number(raw) || 0,
            });
          }}
        />

        <TextField
          name="gratificacion_legal"
          label="Gratificación legal"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.gratificacion_legal || 0)}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              gratificacion_legal: Number(raw) || 0,
            });
          }}
        />

        <TextField
          name="total_no_imponible"
          label="Total no imponible"
          fullWidth
          sx={Input}
          value={nuevoRemuneracion.total_no_imponible}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              total_no_imponible: raw === "" ? "" : Number(raw),
            });
          }}
        />

        <TextField
          label="Seguro cesantía"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.seguro_cesantia || 0)}
          disabled
        />

        <TextField
          label="Total descuentos legales"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.total_descuentos_legales || 0)}
          disabled
        />

        <TextField
          name="total_liquido"
          label="Total líquido"
          fullWidth
          sx={Input}
          value={formatCLP(nuevoRemuneracion.total_liquido || 0)}
          onChange={(e) => {
            const raw = e.target.value.replace(/\./g, "").replace(/\$/g, "");
            setNuevoRemuneracion({
              ...nuevoRemuneracion,
              total_liquido: Number(raw) || 0,
            });
          }}
        />
      </Box>

    </Stack>
  </DialogContent>
  
  <DialogActions sx={{ p: 2 }}>
    <Button sx={buttonCancelar} onClick={handleEditClose}>Cancelar</Button>
    <Button variant="contained" sx={buttonGuardar} onClick={handleSubmitEdit}>
      Guardar
    </Button>
  </DialogActions>
  </Dialog>

  <Dialog
  open={openEliminarDialog}
  onClose={handleCloseEliminarDialog}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
  <DialogTitle id="alert-dialog-title">
    {"¿Estás seguro de que deseas eliminar esta remuneración?"}
  </DialogTitle>
  <DialogActions>
    <Button onClick={handleCloseEliminarDialog} sx={buttonCancelar}>
      Cancelar
    </Button>
    <Button onClick={handleEliminar} sx={buttonGuardar} autoFocus>
      Eliminar
    </Button>
  </DialogActions>
</Dialog>

<Dialog open={openUploadDialog} onClose={handleCloseUploadDialog}>
  <DialogTitle>Subir PDF de Remuneración</DialogTitle>

  <DialogContent>
    <input
      type="file"
      accept="application/pdf"
      onChange={(e) => setSelectedFile(e.target.files[0])}
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseUploadDialog}>Cancelar</Button>

    <Button
      variant="contained"
      disabled={!selectedFile}
      onClick={handleSubmitUploadPDF}
    >
      Subir PDF
    </Button>
  </DialogActions>
</Dialog> */}

      {/* Modales de feedback */}
    {/*   <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert}>
        <Box sx={modalStyle}>
          <section style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress style={{ color: "#2a8d74" }} />
            <p className="alert-text">Procesando solicitud...</p>
          </section>
        </Box>
      </Modal> */}
    </Container>
  );
};
